module.exports = __webpack_public_path__ + "media/images/features/7/plan-konintodoke2-3fc57366210cb4945f1caf6e07556b23.png";